import { useState } from 'react';
import logo from '../../img/title-logo.svg';
import './title-screen.scss';

/**
 * The screen that shows the title and version number of the game, click the logo to activate the dancing letters easter egg
 */
const TitleScreen: React.FC = () => {

  const [dancingLetters, setDancingLetters] = useState<boolean>(false);

  function createBorderElements(count: number): JSX.Element[] {
    const items = [];
    for (let i = 0; i < count; i++) {
      items.push (<div className="border-element" key={i}>?</div>);
    }
    return items;
  };

  return (
  <div className={`title-screen ${dancingLetters && 'dancing-letters'}`}>
    <div className={`title`}>
      <span>W</span><span>O</span><span>R</span><span>D</span>
    </div>
    <div className="logo-container" onClick={()=>{setDancingLetters(!dancingLetters)}}>
      <object 
        className="logo" 
        data={logo} 
        type="image/svg+xml"/>
    </div>
    <div className={`title`}>
      <span>P</span><span>L</span><span>A</span><span>Y</span><span>E</span><span>R</span>
    </div>
    <div className="left-border">
      {createBorderElements(12)}
    </div>
    <div className="right-border">
      {createBorderElements(12)}
    </div>
    <div className="top-border">
      {createBorderElements(25)}
    </div>
    <div className="bottom-border">
      {createBorderElements(25)}
    </div>
    <div className="links">
      <a className="version">
        Version 26.1.22
      </a>
      <a href="privacy.html" target="_blank" className="privacy">
        Privacy Policy
      </a>
    </div>
  </div>
  )
}

export default TitleScreen;